document.addEventListener("DOMContentLoaded", function () {
  const app = document.getElementById("nrk-event-planner");
  const db = window.NRK;
  console.log("NRK DATABASE:", db);

  if (!db || !db.eventTypes) {
    app.innerHTML = "<h2>Planner data not loaded.</h2>";
    return;
  }

   /*
   * Recommendation-page Change My Answers button.
   */
  app.addEventListener("click", function (event) {
    const changeAnswersBtn = event.target.closest(
      "#nrk-change-answers-btn"
    );

    if (changeAnswersBtn) {
      renderQuestion4();
    }
  });

  const state = {
    eventId: null,
    eventTheme: null,
    paxRange: null,
    paxRangeId: null,
    locationArea: null,
    locationStatus: null,
    locationAreaId: null,
    eventDate: null,
    isDecember: false
  };

  const icons = {
    EV_BIRTHDAYS_SOCIAL:
      "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/577E4A8A-318D-41B4-B22C-EADD0B759AB9.jpg?v=1781316900",
    EV_CHILDRENS_PARTY:
      "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/IMG_7741.jpg?v=1780112430",
    EV_CORPORATE:
      "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/50F61BE5-DC40-4750-9333-1A0A1B947700.jpg?v=1781318050",
    EV_COCKTAIL_NETWORKING:
      "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/B6E1310A-E063-48F2-9382-2D088B01E3B1.jpg?v=1781320678",
    EV_WEDDINGS:
      "https://cdn.shopify.com/s/files/1/0262/5457/3648/files/E487324A-E5D4-46C3-BA60-98DD90C12F39.jpg?v=1781316900",
  };

  const paxRanges = [
    {
      id: "PAX_UNDER_30",
      label: "Less than 30 guests",
      note: "We recommend our Party Trays for smaller gatherings.",
      action: "partytrays"
    },
    {
      id: "PAX_30_40",
      label: "30–40 guests",
      action: "continue"
    },
    {
      id: "PAX_50_90",
      label: "50–90 guests",
      action: "continue"
    },
    {
      id: "PAX_100_UP",
      label: "100 guests and above",
      action: "continue"
    }
  ];

  const locationAreas = [
    {
      id: "AREA_METRO_MANILA",
      label: "Metro Manila",
      note: "Within regular service area",
      status: "serviceable"
    },
    {
      id: "AREA_CAVITE",
      label: "Cavite / Tagaytay",
      note: "Within regular service area",
      status: "serviceable"
    },
    {
      id: "AREA_LAGUNA",
      label: "Laguna",
      note: "Within regular service area",
      status: "serviceable"
    },
    {
      id: "AREA_BATANGAS_RIZAL_ANTIPOLO",
      label: "Batangas, Rizal & Antipolo",
      note: "Subject to review",
      status: "review"
    }
  ];

  const eventDateOptions = [
    {
      id: "DATE_JAN_NOV",
      label: "January to November",
      note: "Catering and Rustic Stations start at 30 guests",
      isDecember: false
    },
    {
      id: "DATE_DECEMBER",
      label: "December",
      note: "Catering and Rustic Stations start at 50 guests",
      isDecember: true
    }
  ];

 function renderShell(content) {
  const shouldResetMobileScroll =
    window.matchMedia("(max-width: 768px)").matches &&
    app.innerHTML.trim() !== "";

  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }

  app.innerHTML = `
    <div class="nrk-planner">
      <div class="nrk-card">
        ${content}
      </div>
    </div>
  `;
  if (window.matchMedia("(max-width: 768px)").matches) {
  app.querySelectorAll(".nrk-alt-details").forEach(details => {
    details.removeAttribute("open");
  });
}

const optionsGrid = app.querySelector(".nrk-options");

if (
  optionsGrid &&
  window.matchMedia("(min-width: 1025px)").matches
) {
  const optionCount =
    optionsGrid.querySelectorAll(".nrk-option").length;

  optionsGrid.style.setProperty(
    "grid-template-columns",
    `repeat(${optionCount}, minmax(0, 1fr))`,
    "important"
  );

  optionsGrid.style.setProperty(
    "max-width",
    `${Math.min(optionCount * 260, 1320)}px`,
    "important"
  );

  optionsGrid.style.setProperty(
    "margin",
    "0 auto",
    "important"
  );
 }

if (shouldResetMobileScroll) {
  window.requestAnimationFrame(() => {
    const plannerTop =
      app.getBoundingClientRect().top +
      window.scrollY -
      20;

    window.scrollTo({
      top: plannerTop,
      behavior: "smooth"
    });
  });
}
}

  function renderQuestion1() {
  renderShell(`
    <h1>Let’s Get Planning!</h1>

    <p class="nrk-subtitle">
      Answer 4 quick questions to receive personalized package recommendations
      and sample menu selections in under a minute.
    </p>

    <p class="nrk-privacy-note">
      <strong>No registration or personal information required.</strong>
    </p>

    <p class="nrk-step">Question 1 of 4</p>

    <h2 class="nrk-question-title">Tell Us About Your Event</h2>

    <p class="nrk-subtitle">
      What type of event are you planning?
    </p>
    <div class="nrk-options">
      ${db.eventTypes
        .map(
          event => `
            <button
              type="button"
              class="nrk-option"
              data-event="${event.eventThemeID}"
            >
              <div class="nrk-option-image-wrap">
                ${
                  icons[event.eventThemeID]
                    ? `
                      <img
                        class="nrk-option-image"
                        src="${icons[event.eventThemeID]}"
                        alt="${event.eventTheme}"
                        loading="lazy"
                      >
                    `
                    : `
                      <div class="nrk-icon">✨</div>
                    `
                }
              </div>

              <strong>${event.eventTheme}</strong>

              <span>${event.exampleEvents || ""}</span>
            </button>
          `
        )
        .join("")}
    </div>

    <div id="nrk-selection" class="nrk-selection"></div>
  `);

  document.querySelectorAll(".nrk-option").forEach(button => {
    button.addEventListener("click", function () {
      const eventId = this.dataset.event;

      const selected = db.eventTypes.find(
        event => event.eventThemeID === eventId
      );

      if (!selected) {
        console.error("Event type was not found:", eventId);
        return;
      }

      state.eventId = eventId;
      state.eventTheme = selected.eventTheme;

      document.querySelectorAll(".nrk-option").forEach(optionButton => {
        optionButton.classList.remove("selected");
        optionButton.disabled = true;
      });

      this.classList.add("selected");

      document.getElementById("nrk-selection").innerHTML = `
        <p>You selected:</p>
        <h2>${selected.eventTheme}</h2>
      `;

      window.setTimeout(function () {
        renderQuestion2();
      }, 200);
    });
  });
}
  function renderQuestion2() {
  renderShell(`
    <p class="nrk-step">Question 2 of 4</p>

    <h1>When is your event?</h1>

    <p class="nrk-subtitle">
      This helps us apply the correct minimum requirements.
    </p>

    <div class="nrk-options">
      ${eventDateOptions
        .map(
          option => `
            <button
              type="button"
              class="nrk-option"
              data-date="${option.id}"
            >
              <div class="nrk-icon">
                ${option.isDecember ? "🎄" : "📅"}
              </div>

              <strong>${option.label}</strong>
              <span>${option.note || ""}</span>
            </button>
          `
        )
        .join("")}
    </div>

    <div id="nrk-selection" class="nrk-selection"></div>

    <button type="button" class="nrk-back">
      Back
    </button>
  `);

  document.querySelectorAll(".nrk-option").forEach(button => {
    button.addEventListener("click", function () {
      const dateId = this.dataset.date;

      const selected = eventDateOptions.find(
        option => option.id === dateId
      );

      if (!selected) {
        console.error("Event date option was not found:", dateId);
        return;
      }

      state.eventDate = selected.label;
      state.eventDateId = selected.id;
      state.isDecember = Boolean(selected.isDecember);

      /*
       * Clear answers from the later questions if the user
       * goes back and changes the event date.
       */
      state.paxRange = "";
      state.paxRangeId = "";
      state.locationArea = "";
      state.locationAreaId = "";
      state.locationStatus = "";

      document.querySelectorAll(".nrk-option").forEach(optionButton => {
        optionButton.classList.remove("selected");
        optionButton.disabled = true;
      });

      this.classList.add("selected");

      document.getElementById("nrk-selection").innerHTML = `
        <p>You selected:</p>
        <h2>${selected.label}</h2>
      `;

      window.setTimeout(function () {
        renderQuestion3();
      }, 200);
    });
  });

  document
    .querySelector(".nrk-back")
    .addEventListener("click", renderQuestion1);
}


function renderQuestion3() {
  /*
   * Show all guest ranges.
   * During December, selections below 50 guests
   * are directed to Party Trays.
   */
  const visiblePaxRanges = state.isDecember
  ? [
      {
        id: "PAX_BELOW_50",
        label: "Below 50 guests",
        note: "Party Trays are available as an alternative to full-service catering.",
        action: "partytrays"
      },
      ...paxRanges.filter(
        range =>
          range.id !== "PAX_UNDER_30" &&
          range.id !== "PAX_30_40"
      )
    ]
  : paxRanges;

  renderShell(`
    <p class="nrk-step">Question 3 of 4</p>

    <h1>How many guests are you expecting?</h1>

    <p class="nrk-subtitle">
      ${
        state.isDecember
          ? "December catering minimums start at 50 guests, depending on the package."
          : "Please choose the closest range."
      }
        <br><br>

        <em>
        Planning a large-scale event?<br>
        Select <strong>100 guests and above</strong> to explore suitable starting packages.
        Final requirements and pricing will be reviewed by our team.
        <em>
      </p>
    </p>

    <div class="nrk-options">
      ${visiblePaxRanges
        .map(range => {
          let displayNote = range.note || "";

          if (
            state.isDecember &&
            range.id === "PAX_50_90"
          ) {
            displayNote =
              "Minimum 50 or 70 guests, depending on package";
          }

          return `
            <button
              type="button"
              class="nrk-option"
              data-pax="${range.id}"
            >
              <div class="nrk-icon">👥</div>

              <strong>${range.label}</strong>

              <span>${displayNote}</span>
            </button>
          `;
        })
        .join("")}
    </div>

    <div id="nrk-selection" class="nrk-selection"></div>

    <button type="button" class="nrk-back">
      Back
    </button>
  `);

  document.querySelectorAll(".nrk-option").forEach(button => {
    button.addEventListener("click", function () {
      const paxId = this.dataset.pax;

      const selected = visiblePaxRanges.find(
        range => range.id === paxId
      );

      if (!selected) {
        console.error("Guest range was not found:", paxId);
        return;
      }

      state.paxRange = selected.label;
      state.paxRangeId = selected.id;

      /*
       * Clear the location answer if the user goes back
       * and changes the guest range.
       */
      state.locationArea = "";
      state.locationAreaId = "";
      state.locationStatus = "";

      /*
       * Party Trays apply to:
       *
       * 1. The regular Under 30 Party Trays selection
       * 2. The 30–40 selection during December
       */
      const shouldShowPartyTrays =
        selected.action === "partytrays" ||
        (
          state.isDecember &&
          selected.id === "PAX_30_40"
        );

      if (shouldShowPartyTrays) {
        const partyTrayRecommendations =
          db.partyTrayRecommendations || [];

        const partyTrayCards = partyTrayRecommendations
          .slice(0, 6)
          .map(
            item => `
              <a
                class="nrk-option nrk-party-tray-option"
                href="${item.url}"
                target="_blank"
                rel="noopener"
              >
                ${
                  item.image
                    ? `
                      <img
                        class="nrk-option-image"
                        src="${item.image}"
                        alt="${item.name}"
                        loading="lazy"
                      >
                    `
                    : `
                      <div class="nrk-icon">🍽️</div>
                    `
                }

                <strong>${item.name}</strong>

                <span>
                  ${item.description || ""}
                </span>
              </a>
            `
          )
          .join("");

        const partyTrayMinimumMessage =
          state.isDecember
            ? `
                Our December catering minimums start at
                <strong>50 guests, depending on the package</strong>.
              `
            : `
                Our full-service catering and grazing stations start at
                <strong>30 guests during non-peak months</strong>.
              `;

        renderShell(`
          <p class="nrk-step">Our Recommendation</p>

          <h1>
            Consider our Party Trays for your celebration.
          </h1>

          <p class="nrk-subtitle">
            ${partyTrayMinimumMessage}

            For smaller celebrations, here are some of our
            signature Party Tray favorites.
          </p>

          <div class="nrk-options nrk-party-tray-options">
            ${partyTrayCards}
          </div>

          <div class="nrk-party-tray-actions">
            <a
              class="nrk-party-tray-cta"
              href="/collections/party-trays"
              target="_blank"
              rel="noopener"
            >
              View Our Full Party Tray Selection
              <span aria-hidden="true">→</span>
            </a>
          </div>

          <button type="button" class="nrk-back">
            Back
          </button>
        `);

        const partyTrayBack =
          document.querySelector(".nrk-back");

        if (partyTrayBack) {
          partyTrayBack.addEventListener("click", () => {
            renderQuestion3();
          });
        }

        return;
      }

      document.querySelectorAll(".nrk-option").forEach(
        optionButton => {
          optionButton.classList.remove("selected");
          optionButton.disabled = true;
        }
      );

      this.classList.add("selected");

      document.getElementById("nrk-selection").innerHTML = `
        <p>You selected:</p>
        <h2>${selected.label}</h2>
      `;

      window.setTimeout(function () {
        renderQuestion4();
      }, 200);
    });
  });

  document
    .querySelector(".nrk-back")
    .addEventListener("click", renderQuestion2);
}

function renderQuestion4() {
  renderShell(`
    <p class="nrk-step">Question 4 of 4</p>

    <h1>Where is your event located?</h1>

    <p class="nrk-subtitle">
      Please choose the closest area.
    </p>

    <div class="nrk-options">
      ${locationAreas
        .map(
          area => `
            <button
              type="button"
              class="nrk-option"
              data-area="${area.id}"
            >
              <div class="nrk-icon">📍</div>
              <strong>${area.label}</strong>
              <span>${area.note || ""}</span>
            </button>
          `
        )
        .join("")}
    </div>

    <div id="nrk-selection" class="nrk-selection"></div>

    <button type="button" class="nrk-back">
      Back
    </button>
  `);

  document.querySelectorAll(".nrk-option").forEach(button => {
    button.addEventListener("click", function () {
      const areaId = this.dataset.area;

      const selected = locationAreas.find(
        area => area.id === areaId
      );

      if (!selected) {
        console.error("Location area was not found:", areaId);
        return;
      }

      state.locationArea = selected.label;
      state.locationAreaId = selected.id;
      state.locationStatus = selected.status;

      document.querySelectorAll(".nrk-option").forEach(optionButton => {
        optionButton.classList.remove("selected");
        optionButton.disabled = true;
      });

      this.classList.add("selected");

      document.getElementById("nrk-selection").innerHTML = `
        <p>You selected:</p>
        <h2>${selected.label}</h2>
      `;

      window.setTimeout(function () {
        renderResult();
      }, 200);
    });
  });

  document
    .querySelector(".nrk-back")
    .addEventListener("click", renderQuestion3);
}

 function getSelectedPaxNumber() {
  if (state.paxRangeId === "PAX_30_40") return 30;
  if (state.paxRangeId === "PAX_50_90") return 50;
  if (state.paxRangeId === "PAX_100_UP") return 100;
  return 0;
}

function getPriceForPackage(packageID) {
  const pax = getSelectedPaxNumber();

  return db.pricingMatrix?.find(price =>
    price.packageID === packageID &&
    pax >= Number(price.paxFrom) &&
    pax <= Number(price.paxTo)
  ) || null;
}

function getRecommendedMenus(packageID) {
  const rows = db.packageMenus || [];

  return rows
    .filter(row =>
      row.packageID === packageID &&
      row.available === "Yes"
    )
    .sort((a, b) => (a.recoScore || 999) - (b.recoScore || 999));
}

function normalizeEventTheme(value) {
  return String(value || "")
    .replace(/[’‘]/g, "'")
    .trim()
    .toLowerCase();
}

function getRecommendedAddOns() {
  const selectedTheme = normalizeEventTheme(state.eventTheme);

  return (db.addons || [])
    .filter(addOn =>
      normalizeEventTheme(addOn.recommendFor).includes(selectedTheme)
    )
    .slice(0, 3);
}

function getRecommendations() {
  if (!db.packageScoring || !db.packages) {
    return [];
  }

  const pax = getSelectedPaxNumber();

return db.packageScoring
  .filter(score => {
    const matchesEvent =
      score.eventTheme === state.eventTheme;

    const matchesMinimumPax =
      score.paxFrom === undefined ||
      score.paxFrom === null ||
      score.paxFrom === "" ||
      pax >= Number(score.paxFrom);

    const matchesMaximumPax =
      score.paxTo === undefined ||
      score.paxTo === null ||
      score.paxTo === "" ||
      pax <= Number(score.paxTo);

    return (
      matchesEvent &&
      matchesMinimumPax &&
      matchesMaximumPax
    );
  })
  .map(score => {
    const packageData = db.packages.find(
      pkg => pkg.packageID === score.packageID
    );

    const priceData = getPriceForPackage(score.packageID);
    const menuItems = getRecommendedMenus(score.packageID);

    const minimumPax = state.isDecember
      ? packageData?.minPaxPeakDec
      : packageData?.minPaxRegular;

    return {
      ...score,
      packageData,
      priceData,
      menuItems,
      isEligible: pax >= Number(minimumPax || 0),
      minimumPax
    };
  })
  .filter(item =>
    item.packageData &&
    item.priceData &&
    item.isEligible
  )
  .sort((a, b) =>
    (a.score || 999) - (b.score || 999)
  )
  .slice(0, 2);
}

function renderMenuList(menuItems) {
  const grouped = {};

  function formatMenuItems(items) {
    if (items.length === 1) return items[0];
    if (items.length === 2) return items.join(" & ");

    return `${items.slice(0, -1).join(", ")} & ${items.at(-1)}`;
  }

  menuItems
    .filter(item => Number(item.recoScore) === 1)
    .forEach(item => {
      if (!grouped[item.category]) {
        grouped[item.category] = [];
      }

      grouped[item.category].push(item.menuItem);
    });

  return Object.keys(grouped)
    .map(category => `
      <div class="nrk-menu-row">
        <strong>${category}</strong>
        <span>${formatMenuItems(grouped[category])}</span>
      </div>
    `)
    .join("");
}

  function renderResult() {
  const recommendations = getRecommendations();
  const addOns = getRecommendedAddOns();

  const bestPackage = recommendations[0];
  const alternativePackage = recommendations[1];

  const locationReviewNote =
    state.locationStatus === "review"
      ? `
        <p class="nrk-warning">
          Your selected location is subject to review. We can still recommend starting packages,
          but final availability, minimums, and mobilization will need to be confirmed by our team.
        </p>
      `
      : "";

  const recommendationCards = recommendations.length
    ? `
     <h2 class="nrk-section-title">Our Recommended Packages</h2>
     
    <p class="nrk-photo-disclaimer">
      Photos are representative of our food and styling. Please refer to the recommended menu for inclusions; final package details will be confirmed in the catering contract.
    </p>

    <div class="nrk-dietary-notice">
  <strong>Dietary and Allergen Notice</strong>

    <p>
      Our food is prepared in a shared kitchen that handles eggs, dairy,
      gluten, nuts, seafood, and other allergens. We can identify primary
      ingredients but cannot quantify trace amounts or guarantee against
      cross-contact. We do not offer allergen-free, vegan, fully vegetarian,
      or halal-certified menus. Limited dietary adjustments may be reviewed,
      but our service may not be suitable for guests with severe allergies.
    </p>
  </div>


      <div class="nrk-result-options">
        ${recommendations
          .map(
            (item, index) => `
              <div class="nrk-result-card ${
                index === 0 ? "best" : "alternative"
              }">
                ${
                  item.packageData?.image
                    ? `
                      <img
                        class="nrk-package-image"
                        src="${item.packageData.image}"
                        alt="${
                          item.packageName ||
                          item.packageData?.packageName ||
                          "Recommended catering package"
                        }"
                        loading="lazy"
                      >
                    `
                    : ""
                }

                <div class="nrk-result-header">

                  <div class="nrk-result-title">

                    <div class="nrk-result-label">
                      ${
                        index === 0
                          ? "Best Recommendation"
                          : "Alternative"
                      }
                    </div>

                    <h2>
                      ${
                        item.packageName ||
                        item.packageData?.packageName ||
                        ""
                      }
                    </h2>

                    <p>${item.reason || ""}</p>

                  </div>

                 <div class="nrk-result-price">
                  <small>Starts at</small>

                  ₱${Number(
                    item.pricePerHead ||
                      item.priceData?.basePrice ||
                      0
                  ).toLocaleString()}

                  <span>
                    ${item.packageData?.pricingBasis === "Fixed tier"
                      ? `for ${item.priceData?.paxFrom || ""} guests`
                      : "per head"}
                  </span>

                  ${item.packageData?.pricingBasis === "Fixed tier"
                    ? `
                      <span class="nrk-tier-price-note">
                        Package price increases based on final guest count.
                      </span>
                    `
                    : ""
                  }
                </div>

                </div>
                
                ${
                    index === 1
                      ? `
                        <details class="nrk-alt-details" open>
                          <summary>
                            View sample menu and package details
                          </summary>
                      `
                      : ""
                  }

                  <div class="nrk-result-body">

                    <div class="nrk-result-section">
                      <h4>Recommended Menu</h4>

                      <div class="nrk-menu-preview">
                        ${
                          item.menuItems?.length
                            ? renderMenuList(item.menuItems)
                            : ""
                        }
                      </div>
                    </div>

                    <div class="nrk-result-section">
                      <h4>Package Details</h4>

                      <ul>
                        <li>
                          <strong>Service:</strong>
                          ${item.packageData?.serviceType || ""}
                        </li>

                        <li>
                          <strong>Minimum:</strong>
                          ${item.minimumPax || ""} pax
                          ${state.isDecember ? "for December" : ""}
                        </li>

                        <li>
                          <strong>VAT / Service Charge:</strong>
                          ${
                            item.packageData?.vATSCNote ||
                            "Exclusive of VAT, service charge and mobilization"
                          }
                        </li>

                        <li>
                          <strong>Mobilization Fee:</strong>
                          To be confirmed based on the overall package, venue, and service requirements
                        </li>
                      </ul>
                    </div>

                  </div>

                  ${index === 1 ? `</details>` : ""}

              </div>
            `
          )
          .join("")}
      </div>

      ${
        addOns.length
          ? `
            <h2 class="nrk-section-title">Recommended Add-ons</h2>

            <div class="nrk-addons">
              ${addOns
                .map(
                  addOn => `
                    <div class="nrk-addon">

                      <strong>${addOn.addOnName || ""}</strong>

                      <div style="margin-top: 8px;">
                        ${addOn.pricing || ""}
                      </div>

                      <div>
                        ${addOn.minTiers || ""}
                      </div>

                      <div style="margin-top: 8px; font-size: 14px; color: #777;">
                        ${addOn.reasonTemplate || ""}
                      </div>

                    </div>
                  `
                )
                .join("")}
            </div>
          `
          : ""
      }
    `
    : `
      <p class="nrk-warning">
       We’d like to review your event details before recommending a package.
       Please contact our team through Viber at 0998-5648344 so we can help
       identify the most suitable options for your event.
      </p>
    `;

  renderShell(`
  <div id="nrk-pdf-content">

    <div class="nrk-reco-header">
      <img
        class="nrk-reco-logo"
        src="https://cdn.shopify.com/s/files/1/0262/5457/3648/files/IMG_9156.jpg?v=1780114071"
        alt="Natalia's Rustic Kitchen"
        crossorigin="anonymous"
      >

      <div class="nrk-reco-contact">
        <a href="tel:+639985648344">
          <span class="nrk-contact-icon">☎</span>
          0998-5648344
        </a>

        <a href="mailto:sales@nataliasrustickitchen.com">
          <span class="nrk-contact-icon">✉</span>
          sales@nataliasrustickitchen.com
        </a>
        
        <div class="nrk-location-contact">
          <span class="nrk-contact-icon">⌖</span>
          <span>Based in Daang Hari, Bacoor, Cavite</span>
        </div>

        <div class="nrk-social-contact">
          <a
            href="https://www.facebook.com/nataliasrustickitchen"
            target="_blank"
            rel="noopener"
            aria-label="Facebook"
          >
            <span class="nrk-contact-icon nrk-facebook-icon">f</span>
          </a>

          <a
            href="https://www.instagram.com/nataliasrustickitchen"
            target="_blank"
            rel="noopener"
            aria-label="Instagram"
          >
            <span class="nrk-contact-icon nrk-instagram-icon">◎</span>
          </a>

          <span>@nataliasrustickitchen</span>
        </div>
      </div>
    </div>

    <p class="nrk-step">Your Event Summary</p>

      <div class="nrk-summary">

        <p>
          <strong>Event Type:</strong>
          ${state.eventTheme || ""}
        </p>

        <p>
          <strong>Guests:</strong>
          ${state.paxRange || ""}
        </p>

        <p>
          <strong>Location:</strong>
          ${state.locationArea || ""}
        </p>

        <p>
          <strong>Date:</strong>
          ${state.eventDate || ""}
        </p>

      </div>

      ${locationReviewNote}
      <button
        type="button"
        id="nrk-change-answers-btn"
        class="nrk-back-btn nrk-no-pdf"
      >
        ← Change My Answers
      </button>

      ${recommendationCards}

    </div>

    <div class="nrk-next-steps">

      <h2>Your Next Steps</h2>

      <p class="nrk-privacy-note">
        <strong>Your privacy matters.</strong><br>
        You completed the planner without sharing any personal information. We only
        receive your details if you choose to request our complete menu catalog or
        a formal quotation.
      </p>

      <div class="nrk-next-grid">

        <div class="nrk-next-card">

          <div class="nrk-next-icon">💬</div>

          <h3>Get our Complete Packages</h3>

          <p>
            Receive our catering packages, menus, and pricing instantly on Viber.
          </p>

          <button
            id="nrk-viber-btn"
            class="nrk-cta-btn"
            type="button"
          >
            Open Viber
          </button>

        </div>

        <div class="nrk-next-card">

          <div class="nrk-next-icon">📋</div>

          <h3>Request a Formal Quote</h3>

          <p>
            Share more details and we’ll prepare a formal quotation for your event.
          </p>

          <button
            id="nrk-quote-btn"
            class="nrk-cta-btn"
            type="button"
          >
            Request Quote
          </button>

        </div>

        <div class="nrk-next-card">

          <div class="nrk-next-icon">🍽️</div>

          <h3>Try Our Food</h3>

          <p>
            We don’t offer traditional food tastings, but you can sample our food by ordering from our Party Trays menu.
          </p>

          <a
            href="/collections/party-trays"
            id="nrk-party-trays-btn"
            class="nrk-cta-btn"
            target="_blank"
            rel="noopener"
          >
            Order Party Trays
          </a>
          
        </div>

        <div class="nrk-next-card">

          <div class="nrk-next-icon">📄</div>

          <h3>Download My Recommendations</h3>

          <p>
            Save a PDF copy of your personalized recommendations for future
            reference or to share with family and friends.
          </p>

          <button
            id="nrk-download-btn"
            class="nrk-cta-btn"
            type="button"
          >
            Download PDF
          </button>

        </div>

      </div>
    </div>
  `);

   /*
   * Planner completion tracking
   */
  if (
    typeof gtag === "function" &&
    !state.plannerCompletionTracked
  ) {
    gtag("event", "planner_completed", {
      event_type: state.eventTheme || "",
      guest_range: state.paxRange || "",
      location: state.locationArea || "",
      december_event: state.isDecember || false
    });

    state.plannerCompletionTracked = true;
  }

  /*
   * Back button
   */
  const backBtn = document.querySelector(".nrk-back");

  if (backBtn) {
    backBtn.addEventListener("click", renderQuestion4);
  }

  /*
   * Viber CTA
   */
  const viberBtn = document.getElementById("nrk-viber-btn");

  if (viberBtn) {
    viberBtn.addEventListener("click", async event => {
      event.preventDefault();

      if (typeof gtag === "function") {
        gtag("event", "viber_cta_click");
      }

      const recommendedPackageName =
        bestPackage?.packageName ||
        bestPackage?.packageData?.packageName ||
        "Recommended Package";

      const viberMessage =
        "Hi Natalia's Rustic Kitchen!\n\n" +
        "I just completed your Event Planner and would like to receive your complete catering packages and menu options.\n\n" +
        "Recommended Package: " +
        recommendedPackageName +
        "\n\n" +
        "Event Details:\n" +
        "Event Type: " +
        (state.eventTheme || "") +
        "\n" +
        "Guests: " +
        (state.paxRange || "") +
        "\n" +
        "Location: " +
        (state.locationArea || "") +
        "\n" +
        "Event Date: " +
        (state.eventDate || "") +
        "\n\n" +
        "Thank you!";

      try {
        await navigator.clipboard.writeText(viberMessage);

        alert(
          "Your event summary has been copied. Viber will open next—please paste (Ctrl+V or Command+V) the message into the chat and send."
        );
      } catch (error) {
        console.warn("Clipboard copy failed:", error);

        alert(
          "Viber will open next. Please return to this page if you need to copy your event details manually."
        );
      }

      window.location.href =
        "viber://forward?text=" + encodeURIComponent(viberMessage);
    });
  }

    /*
 * Hulk quote form CTA
 * Copies the recommendation summary, then opens the quote form
 */
const quoteBtn = document.getElementById("nrk-quote-btn");

if (quoteBtn) {
  quoteBtn.addEventListener("click", async event => {
    event.preventDefault();

    if (typeof gtag === "function") {
      gtag("event", "quote_cta_click");
    }

    const recommendedPackageName =
      bestPackage?.packageName ||
      bestPackage?.packageData?.packageName ||
      "No automatic recommendation";

    const alternativePackageName =
      alternativePackage?.packageName ||
      alternativePackage?.packageData?.packageName ||
      "";

    const recommendedRate = bestPackage
      ? "₱" +
        Number(
          bestPackage.pricePerHead ||
            bestPackage.priceData?.basePrice ||
            0
        ).toLocaleString() +
        " per head"
      : "";

    const alternativeRate = alternativePackage
      ? "₱" +
        Number(
          alternativePackage.pricePerHead ||
            alternativePackage.priceData?.basePrice ||
            0
        ).toLocaleString() +
        " per head"
      : "";

    const plannerSummary =
      "EVENT PLANNER RECOMMENDATION\n\n" +

      "Best Recommendation\n" +
      recommendedPackageName +
      (recommendedRate ? "\nRate: " + recommendedRate : "") +
      (bestPackage?.reason
        ? "\nWhy: " + bestPackage.reason
        : "") +

      (alternativePackageName
        ? "\n\nAlternative Package\n" +
          alternativePackageName +
          (alternativeRate
            ? "\nRate: " + alternativeRate
            : "") +
          (alternativePackage?.reason
            ? "\nWhy: " + alternativePackage.reason
            : "")
        : "") +

      "\n\nEvent Details\n" +
      "Event Type: " +
      (state.eventTheme || "") +
      "\nGuests: " +
      (state.paxRange || "") +
      "\nLocation: " +
      (state.locationArea || "") +
      "\nEvent Date: " +
      (state.eventDate || "") +

      (state.locationStatus === "review"
        ? "\n\nNote: Your selected location is subject to review. Final availability and mobilization charges will be confirmed by our team."
        : "") +

      "\n\nIf you would like your quotation to include add-ons or upgrades, please indicate them in the Package Request field before submitting the form.";

    try {
      await navigator.clipboard.writeText(plannerSummary);

      alert(
        "Your event recommendation has been copied. The quote request form will open next. Please paste the recommendation into the Package Request field (Ctrl+V or Command+V), then add any optional upgrades before submitting."
      );
    } catch (error) {
      console.warn("Clipboard copy failed:", error);

      alert(
        "The quote request form will open next. Please paste your recommendation into the Package Request field. If you add any optional upgrades before submitting."
      );
    }

    window.open(
      "https://nataliasrustickitchen.com/pages/celebrate-with-us-catering-quote-request",
      "_blank",
      "noopener,noreferrer"
    );
  });
}
  /*
  * Party Trays CTA
  */
  const partyTraysBtn = document.getElementById("nrk-party-trays-btn");

  if (partyTraysBtn) {
    partyTraysBtn.addEventListener("click", () => {
      if (typeof gtag === "function") {
        gtag("event", "party_trays_cta_click");
      }
    });
  }

  /*
 * PDF download CTA
 */
const downloadBtn = document.getElementById("nrk-download-btn");

if (downloadBtn) {
  const isPhone = window.matchMedia("(max-width: 767px)").matches;

  if (!isPhone) {
    downloadBtn.disabled = true;
    downloadBtn.textContent = "Mobile Phone Download Only";

    const mobileNote = document.createElement("p");
    mobileNote.className = "nrk-mobile-download-note";
    mobileNote.textContent =
      "To download a copy, please complete the planner on a mobile phone.";

    downloadBtn.insertAdjacentElement("afterend", mobileNote);
  } else {
    downloadBtn.addEventListener("click", event => {
      event.preventDefault();

      if (typeof gtag === "function") {
        gtag("event", "pdf_download_cta_click");
      }

      generateRecommendationPDF();
    });
  }
}

}

async function generateRecommendationPDF() {
  const pdfContent = document.getElementById("nrk-pdf-content");
  const downloadBtn = document.getElementById("nrk-download-btn");

  if (!pdfContent) {
    alert("We could not find your recommendation to download.");
    return;
  }

  if (
    typeof html2canvas === "undefined" ||
    !window.jspdf ||
    !window.jspdf.jsPDF
  ) {
    alert(
      "The PDF tool has not loaded. Please refresh the page and try again."
    );
    return;
  }

  const originalButtonText = downloadBtn
    ? downloadBtn.textContent
    : "Download PDF";

  if (downloadBtn) {
    downloadBtn.disabled = true;
    downloadBtn.textContent = "Preparing PDF...";
  }

  let pdfWrapper = null;

  try {
    /*
     * Wait for live recommendation images.
     */
    const sourceImages = Array.from(
      pdfContent.querySelectorAll("img")
    );

    await Promise.all(
      sourceImages.map(image => {
        if (image.complete) {
          return Promise.resolve();
        }

        return new Promise(resolve => {
          image.addEventListener("load", resolve, { once: true });
          image.addEventListener("error", resolve, { once: true });
        });
      })
    );

    /*
     * Clone the recommendation.
     */
    const pdfClone = pdfContent.cloneNode(true);

    pdfClone.removeAttribute("id");
    pdfClone.id = "nrk-pdf-export-content";

    /*
     * Open alternative package details.
     */
    pdfClone
      .querySelectorAll("details.nrk-alt-details")
      .forEach(details => {
        details.open = true;
        details.setAttribute("open", "");

        const summary = details.querySelector("summary");

        if (summary) {
          summary.remove();
        }
      });

    /*
     * Remove webpage-only elements.
     */
    pdfClone
      .querySelectorAll(`
        #nrk-download-btn,
        .nrk-download-btn,
        .nrk-next-steps,
        .nrk-result-cta,
        .nrk-pdf-hide,
        .nrk-no-pdf,
        .nrk-dietary-notice,
        .nrk-photo-disclaimer,
        button
      `)
      .forEach(element => element.remove());
    
    /*
    * Create the temporary PDF wrapper below the visible page.
    */
    pdfWrapper = document.createElement("div");
    pdfWrapper.id = "nrk-pdf-export-wrapper";

    const exportTop =
      Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      ) + 50;

    Object.assign(pdfWrapper.style, {
      position: "absolute",
      left: "0",
      top: `${exportTop}px`,
      zIndex: "0",
      width: "760px",
      minWidth: "760px",
      maxWidth: "760px",
      margin: "0",
      padding: "16px",
      backgroundColor: "#ffffff",
      boxSizing: "border-box",
      overflow: "visible",
      pointerEvents: "none"
    });

    Object.assign(pdfClone.style, {
      display: "block",
      position: "relative",
      width: "100%",
      maxWidth: "100%",
      minWidth: "0",
      margin: "0",
      padding: "0",
      backgroundColor: "#ffffff",
      boxSizing: "border-box",
      overflow: "visible",
      transform: "none",
      opacity: "1",
      visibility: "visible"
    });

    /*
     * PDF-only styling.
     */
    const pdfStyle = document.createElement("style");

    pdfStyle.textContent = `
      #nrk-pdf-export-wrapper,
      #nrk-pdf-export-wrapper * {
        box-sizing: border-box !important;
        visibility: visible !important;
        opacity: 1 !important;
      }

      #nrk-pdf-export-wrapper {
        width: 760px !important;
        max-width: 760px !important;
        margin: 0 !important;
        padding: 16px !important;
        font-size: 10px !important;
        line-height: 1.3 !important;
        background: #ffffff !important;
      }

      #nrk-pdf-export-wrapper #nrk-pdf-export-content,
      #nrk-pdf-export-wrapper .nrk-planner,
      #nrk-pdf-export-wrapper .nrk-card {
        display: block !important;
        position: relative !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        transform: none !important;
        opacity: 1 !important;
        visibility: visible !important;
        overflow: visible !important;
      }

      #nrk-pdf-export-wrapper .nrk-card {
        padding: 16px !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }

      #nrk-pdf-export-wrapper h1 {
        font-size: 22px !important;
        line-height: 1.15 !important;
        margin: 0 0 10px !important;
      }

      #nrk-pdf-export-wrapper h2 {
        font-size: 16px !important;
        line-height: 1.25 !important;
        margin: 12px 0 8px !important;
      }

      #nrk-pdf-export-wrapper h3 {
        font-size: 14px !important;
        line-height: 1.25 !important;
        margin: 8px 0 6px !important;
      }

      #nrk-pdf-export-wrapper p {
        margin: 4px 0 7px !important;
      }

      #nrk-pdf-export-wrapper p,
      #nrk-pdf-export-wrapper li,
      #nrk-pdf-export-wrapper span,
      #nrk-pdf-export-wrapper strong {
        max-width: 100% !important;
        white-space: normal !important;
        overflow-wrap: break-word !important;
        word-break: normal !important;
      }

      #nrk-pdf-export-wrapper .nrk-subtitle {
        max-width: 100% !important;
        margin: 0 0 14px !important;
        font-size: 13px !important;
      }

      /*
       * Header and contact details.
       */
      #nrk-pdf-export-wrapper .nrk-reco-header {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 20px !important;
        width: 100% !important;
        margin-bottom: 16px !important;
        padding: 14px 18px !important;
        text-align: left !important;
      }

      #nrk-pdf-export-wrapper .nrk-reco-logo {
        width: 78px !important;
        height: 78px !important;
        max-width: 78px !important;
        max-height: 78px !important;
        flex: 0 0 78px !important;
        object-fit: contain !important;
      }

      #nrk-pdf-export-wrapper .nrk-reco-contact {
        display: grid !important;
        grid-template-columns: repeat(2, max-content) !important;
        align-items: center !important;
        justify-content: end !important;
        gap: 8px 16px !important;
      }

      #nrk-pdf-export-wrapper .nrk-location-contact {
        justify-self: start !important;
      }

      #nrk-pdf-export-wrapper .nrk-social-contact {
        justify-self: end !important;
      }

      #nrk-pdf-export-wrapper .nrk-reco-contact a,
      #nrk-pdf-export-wrapper .nrk-location-contact,
      #nrk-pdf-export-wrapper .nrk-social-contact {
        font-size: 10px !important;
      }

      #nrk-pdf-export-wrapper .nrk-contact-icon {
        width: 20px !important;
        height: 20px !important;
        flex: 0 0 20px !important;
        font-size: 10px !important;
      }

      /*
       * Event summary.
       */
      #nrk-pdf-export-wrapper .nrk-summary {
        display: grid !important;
        grid-template-columns: 1fr 1fr !important;
        gap: 4px 14px !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 0 16px !important;
        padding: 10px 12px !important;
      }

      /*
      * Package cards.
      */
      #nrk-pdf-export-wrapper .nrk-result-options {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
      }

      #nrk-pdf-export-wrapper .nrk-result-options > .nrk-result-card {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin: 0 0 12px !important;
      }

      #nrk-pdf-export-wrapper .nrk-result-card,
      #nrk-pdf-export-wrapper .nrk-addon,
      #nrk-pdf-export-wrapper .nrk-warning,
      #nrk-pdf-export-wrapper .nrk-location-note {
        display: block !important;
        position: relative !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        padding: 12px !important;
        overflow: visible !important;
        transform: none !important;
      }

      #nrk-pdf-export-wrapper .nrk-result-card {
        padding: 14px 20px !important;
      }
      #nrk-pdf-export-wrapper .nrk-result-header {
        display: block !important;
        width: 100% !important;
      }

      #nrk-pdf-export-wrapper .nrk-result-title,
      #nrk-pdf-export-wrapper .nrk-result-price {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin: 0 0 6px !important;
        text-align: left !important;
      }

      #nrk-pdf-export-wrapper .nrk-result-title h2 {
        width: 100% !important;
        max-width: 100% !important;
        margin: 6px 0 8px !important;
        padding: 0 !important;
        font-size: 18px !important;
        line-height: 1.25 !important;
        overflow-wrap: break-word !important;
      }

      /*
       * Package images:
       * natural proportions, left aligned and slightly wider.
       */
      #nrk-pdf-export-wrapper .nrk-package-image {
        display: block !important;
        float: right !important;
        width: 220px !important;
        max-width: 34% !important;
        height: 125px !important;
        max-height: 125px !important;
        margin: 0 0 12px 18px !important;
        object-fit: cover !important;
        object-position: center !important;
        border-radius: 8px !important;
        background: #f7f4ef !important;
      }

      #nrk-pdf-export-wrapper img:not(.nrk-package-image) {
        max-width: 100% !important;
        height: auto !important;
        object-fit: contain !important;
      }

      /*
       * Menu inclusions.
       */
      #nrk-pdf-export-wrapper .nrk-result-body {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        align-items: start !important;
        clear: both !important;
        gap: 12px !important;
        width: 100% !important;
      }    

      #nrk-pdf-export-wrapper .nrk-result-section {
        min-width: 0 !important;
      }

      /*
       * Alternative package.
       */
      #nrk-pdf-export-wrapper details.nrk-alt-details,
      #nrk-pdf-export-wrapper details.nrk-alt-details[open] {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        opacity: 1 !important;
        visibility: visible !important;
      }

      #nrk-pdf-export-wrapper details.nrk-alt-details .nrk-result-body {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 12px !important;
        width: 100% !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        opacity: 1 !important;
        visibility: visible !important;
      }

      /*
       * Add-ons.
       */
      #nrk-pdf-export-wrapper .nrk-addons,
      #nrk-pdf-export-wrapper .nrk-addon-grid {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
        gap: 10px !important;
        width: 100% !important;
        max-width: 100% !important;
      }

      #nrk-pdf-export-wrapper .nrk-addon {
        display: block !important;
        margin: 0 !important;
      }
    `;

    pdfWrapper.appendChild(pdfStyle);
    pdfWrapper.appendChild(pdfClone);
    document.body.appendChild(pdfWrapper);

    /*
     * Wait for PDF styling to render.
     */
    await new Promise(resolve => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

    /*
     * Wait for fonts.
     */
    if (document.fonts && document.fonts.ready) {
      await document.fonts.ready;
    }

    /*
    * Prevent mobile Safari from waiting indefinitely for cloned images.
    */
    const clonedImages = Array.from(
      pdfClone.querySelectorAll("img")
    );

    clonedImages.forEach(image => {
      image.loading = "eager";
    });

    await new Promise(resolve => setTimeout(resolve, 800));

    /*
    * Final layout calculation.
    */
    await new Promise(resolve => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

    /*
     * Final layout calculation.
     */
    await new Promise(resolve => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

    const eventName = (state.eventTheme || "Event")
      .replace(/[^a-z0-9]/gi, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    const canvas = await Promise.race([
      html2canvas(pdfWrapper, {
        scale: 1,
        useCORS: true,
        allowTaint: false,
        logging: true,
        backgroundColor: "#ffffff",
        width: 760,
        windowWidth: 760,
        scrollX: 0,
        scrollY: 0,
        imageTimeout: 5000
      }),

      new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error("PDF capture timed out."));
        }, 15000);
      })
    ]);

    if (!canvas.width || !canvas.height) {
      throw new Error("The PDF canvas was empty.");
    }

    const imageData = canvas.toDataURL("image/jpeg", 0.92);

    if (!imageData || imageData === "data:,") {
      throw new Error("The PDF image could not be created.");
    }

    const jsPDFConstructor =
      window.jspdf?.jsPDF ||
      window.jsPDF;

    if (!jsPDFConstructor) {
      throw new Error("jsPDF has not loaded.");
    }

    const pdf = new jsPDFConstructor({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true
    });

    const pageWidth = 210;
    const pageHeight = 297;
    const margin = 8;
    const usableWidth = pageWidth - margin * 2;
    const usableHeight = pageHeight - margin * 2;

    const imageRatio = canvas.height / canvas.width;

    let pdfImageWidth = usableWidth;
    let pdfImageHeight = pdfImageWidth * imageRatio;

    /*
    * Shrink the complete recommendation to one page.
    */
    if (pdfImageHeight > usableHeight) {
      pdfImageHeight = usableHeight;
      pdfImageWidth = pdfImageHeight / imageRatio;
    }

    const imageX = (pageWidth - pdfImageWidth) / 2;
    const imageY = margin;

    pdf.addImage(
      imageData,
      "JPEG",
      imageX,
      imageY,
      pdfImageWidth,
      pdfImageHeight,
      undefined,
      "FAST"
    );

    pdf.save(
      `NRK-${eventName || "Event"}-Recommendations.pdf`
    );

  } catch (error) {
    console.error("PDF generation failed:", error);

    alert(
      "We could not generate the PDF. Please refresh the page and try again."
    );
  } finally {
    if (pdfWrapper && pdfWrapper.parentNode) {
      pdfWrapper.parentNode.removeChild(pdfWrapper);
    }

    if (downloadBtn) {
      downloadBtn.disabled = false;
      downloadBtn.textContent = originalButtonText;
    }
  }
}
renderQuestion1();

});